import React, { useEffect } from 'react'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcFlexBox,
  DcInput,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'

import { UpdateCustomerInfo } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../../decl'

const EditCustomerInfo = (props) => {
  const { handleClose, customer } = props
  const [data, setData] = React.useState({
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    company: '',
    customer_reference: '',
  })
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const newCustomer = () => {
    showPageLoader()
    UpdateCustomerInfo(data).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        showSuccess('Successfully Updated')

        handleClose(res.response.data)
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
      }
    })
  }
  useEffect(() => {
    setData({ ...data, ...customer })
  }, [customer])
  const handleSubmit = (e) => {
    e.preventDefault()
    newCustomer()
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <DcText>Primary Contact:</DcText>
        <DcFlexBox gap="10px" height="auto">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              First Name
            </DcText>
            <DcInput
              error={
                error.field === 'first_name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'First Name'}
              placeholder={'First Name'}
              value={data.first_name}
              onChange={(e) => setData({ ...data, first_name: e.target.value })}
            />
          </DcDiv>

          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Last Name
            </DcText>
            <DcInput
              error={
                error.field === 'last_name' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'Last Name'}
              placeholder={'Last Name'}
              value={data.last_name}
              onChange={(e) => setData({ ...data, last_name: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox gap="10px" height="auto">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Contact Number
            </DcText>
            <DcInput
              error={
                error.field === 'phone' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'Name'}
              placeholder={'Contact Number'}
              value={data.phone}
              onChange={(e) => setData({ ...data, phone: e.target.value })}
            />
          </DcDiv>

          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Email
            </DcText>
            <DcInput
              error={
                error.field === 'email' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'email'}
              placeholder={'Email'}
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox gap="10px" height="auto">
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Company Name
            </DcText>
            <DcInput
              error={
                error.field === 'company' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'Company'}
              placeholder={'Company Name'}
              value={data.company}
              onChange={(e) => setData({ ...data, company: e.target.value })}
            />
          </DcDiv>

          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '16px',

              textAlign: 'left',
            }}
          >
            <DcText
              fontSize=".875rem"
              fontWeight="500"
              customColor="#2e314a"
              style={{
                textAlign: 'left',
                margin: '0 0 0.5rem 0',
              }}
            >
              Customer Reference
            </DcText>
            <DcInput
              error={
                error.field === 'customer_reference' && error.error !== ''
                  ? error.error
                  : null
              }
              type={'text'}
              name={'Customer Reference'}
              placeholder={'Customer Reference'}
              value={data.customer_reference}
              onChange={(e) =>
                setData({ ...data, customer_reference: e.target.value })
              }
            />
          </DcDiv>
        </DcFlexBox>
        <DcFlexBox style={{ padding: '10px 0 0 0' }} justifyContent="flex-end">
          <DcButton
            type={'submit'}
            size="sm"
            style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
          >
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </DcFlexBox>
      </Form>
    </>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
`

export default EditCustomerInfo
